// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__l7XBF","right":"Footer_right__2lwhc","buttons":"Footer_buttons__1fyMx"};